module.exports = __webpack_public_path__ + "static/tabsCover-881dff5fc7562f99208865bb08530a9b.jpg";